import styled, { css } from 'styled-components';

const InputStyle = css`
  min-width: none;
  width: 100%;
  border: none;
  outline: none;
  padding: 0;
  background-color: transparent;
  font: inherit;
`;

export const Input = styled.input`
  ${InputStyle};
`;

export const Disabled = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  background-color: ${(props) => props.theme.ui.input.disabledBgColor};
`;

export const Select = styled.select`
  ${InputStyle};
`;
